import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatDollars', standalone: true })
export class FormatDollarsPipe implements PipeTransform {
  transform(value: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(value);
  }
}
